/**
 * CardList Component - Displays bingo cards
 */

import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Card from '../common/Card';
import Table from '../common/Table';
import Button from '../common/Button';
import api from '../../services/api';
import './Cards.css';

const CardList = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCards();
  }, []);

  const loadCards = async () => {
    try {
      setLoading(true);
      const data = await api.getCards();
      setCards(data.cards || data || []);
    } catch (error) {
      console.error('Error loading cards:', error);
      toast.error('Error al cargar cartones');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { 
      key: '_id', 
      label: 'ID', 
      width: '100px',
      render: (val) => val?.substring(0, 8) + '...'
    },
    { 
      key: 'player', 
      label: 'Jugador',
      render: (val) => val?.username || 'N/A'
    },
    { 
      key: 'game', 
      label: 'Juego',
      render: (val) => val?._id?.substring(0, 8) + '...' || 'N/A'
    },
    { 
      key: 'markedNumbers', 
      label: 'Marcados',
      render: (val) => val?.length || 0
    },
    { 
      key: 'isWinner', 
      label: 'Ganador',
      render: (val) => (
        <span className={`status-badge status-${val ? 'winner' : 'normal'}`}>
          {val ? '🏆 Sí' : 'No'}
        </span>
      )
    },
    { 
      key: 'createdAt', 
      label: 'Creado',
      render: (val) => val ? new Date(val).toLocaleString() : 'N/A'
    },
  ];

  return (
    <div className="card-list">
      <Card
        title="Cartones de Bingo"
        subtitle={`${cards.length} cartones totales`}
        actions={<Button onClick={loadCards}>Actualizar</Button>}
      >
        <Table 
          columns={columns} 
          data={cards} 
          loading={loading} 
          emptyMessage="No hay cartones. Los cartones se generan cuando los jugadores compran en un juego."
        />
      </Card>
    </div>
  );
};

export default CardList;
